<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <span class="font-16 font-calibri font-weight-bold">Bank</span>
        <employee-profile-payroll-bank-detail-dialog-edit
          v-if="$hasPermissionTo(['update employee payroll']) && !isResigned"
          :bank-detail="bankDetail"
          :employee-uid="employeeUid"
          @updated="loadEmployeeBanks"
        />
      </v-col>
    </v-row>

    <v-row class="mx-0">
      <v-col
        cols="4"
        class="pa-0"
      >
        <span class="font-weight-medium">Payment Method</span>
      </v-col>
      <v-col
        cols="1"
        class="pa-0"
      >
        <span class="font-weight-medium">:</span>
      </v-col>
      <v-col
        cols="7"
        class="pa-0"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="20"
          width="3"
          color="primary"
          class="ml-3"
        />
        <span
          v-else
          class="pl-3"
        >
          {{ ((bankDetail||{}).payment_method||{}).name ||'N/A' }}
        </span>
      </v-col>
     
      <v-col
        cols="4"
        class="pa-0"
      >
        <span class="font-weight-medium">Bank</span>
      </v-col>
      <v-col
        cols="1"
        class="pa-0"
      >
        <span class="font-weight-medium">:</span>
      </v-col>
      <v-col
        cols="7"
        class="pa-0"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="20"
          width="3"
          color="primary"
          class="ml-3"
        />
        <span
          v-else
          class="pl-3"
        >
          {{ ((bankDetail||{}).bank||{}).name ||'N/A' }}
        </span>
      </v-col>
      
      <v-col
        cols="4"
        class="pa-0"
      >
        <span class="font-weight-medium">Account Number</span>
      </v-col>
      <v-col
        cols="1"
        class="pa-0"
      >
        <span class="font-weight-medium">:</span>
      </v-col>
      <v-col
        cols="7"
        class="pa-0"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="20"
          width="3"
          color="primary"
          class="ml-3"
        />
        <span
          v-else
          class="pl-3"
        >
          {{ (bankDetail||{}).bank_account_number ||'N/A' }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollBankDetailDialogEdit: () => import('@/components/hris/employee/profile/payroll/bank-detail/DialogEdit'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        bankDetail: {},
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEmployeeBanks()
          }
        },
      },
    },
  
    methods: {
      loadEmployeeBanks () {
        this.loading = true

        this.$api.employeePayrollBanks().list(this.employeeUid)
          .then(res => {
            this.bankDetail = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}
</style>
